export default __webpack_public_path__ + "static/media/babylist.f0cb88fc.webp";